<div class="pb-5 pt-4 border-b border-neutral-300">
  <p class="font-bold font-accent text-1xsl leading-7">
    {{ 'payment.means-of-payment' | translate }}
  </p>
  <p class="py-1 text-md text-neutral-600 leading-5.5">
    {{ paymentsString }}
  </p>
</div>
